// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__XsetY","label":"styles_label__3gkGT"};